

import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import lrz from 'lrz'
import vueFilter from './util/filters'
for (const key in vueFilter) {
Vue.filter(key, vueFilter[key]);
}


import Vant from 'vant';
import 'vant/lib/index.css';


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import '@/assets/css/common.less'
import '@/assets/css/reset.less'

import { Toast } from 'vant';


import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)


Vue.use(ToastPlugin, { position: 'top' })
Vue.use(Vant);
Vue.use(ElementUI);

import axios from 'axios'
Vue.prototype.$axios = axios


Vue.config.productionTip = false;






function renderContent() {
/****** request拦截器==>对请求参数做处理 ******/
axios.interceptors.request.use(
config => {
Vue.$vux.loading.show({ text: config.loadingText || '' })
if (config.data == undefined) {
config.data = {}
}
return config;
},
err => {
Vue.$vux.loading.hide();
Vue.$vux.toast.show({ text: '请求失败', time: 2000, type: 'text', width: '1.6rem' })
return Promise.reject(err);
});
/****** respone拦截器==>对响应做处理 ******/
axios.interceptors.response.use(function(response) {

if (!response.config.notHideLoading) {

Vue.$vux.loading.hide();
}
if (response.data.code !== 200) {
if (response.data.message) {
Vue.$vux.confirm.show({ content: response.data.message, showCancelButton: false, confirmText: '关闭', hideOnBlur: true })
} else {
if (response.config.url == '/wechat/city/allCity.do' || response.config.url.indexOf("/wechat/towerName/towerName.do") != -1 ||
response.config.url.indexOf("/wechat/supplementaryNotice") != -1|| response.config.url.indexOf("/wechat/createUser.do") != -1||
response.config.url.indexOf("/wechat/homeName/homeName.do") != -1 || response.config.url.indexOf("/wechat/guidePrice/massage.do") != -1 ||
response.config.url.indexOf("/wechat/homeNum/homeNum.do") != -1 || response.config.url.indexOf("/wechat/estateEvaluation/estateVo.do") != -1 ||
response.config.url.indexOf('/wechat/printInfo/printInfoSave.do') != -1) {

} else if (response.config.url.indexOf('iobs-upload.pingan.com.cn/upload/') != -1) {

} else {
Vue.$vux.toast.show({ text: '接口未拦截，错误提示'+response.config.url, time: 2000, type: 'text', width: '1.6rem' })
}
}
}
return response;
}, function(error) {

Vue.$vux.loading.hide();
if (error.response && error.response.config.url.indexOf('stg-iobs-upload.pingan.com.cn/upload/') != -1 && error.response.status == 401) {

Vue.$vux.toast.show({ text: '凭证已过期，请返回上个页面重新获取凭证', time: 2000, type: 'text', width: '4.4rem' })
} else if (error) {
Vue.$vux.toast.show({ text: error, time: 2000, type: 'text', width: '2.4rem' })
} else {
Vue.$vux.toast.show({ text: '连接服务器失败', time: 2000, type: 'text', width: '2.4rem' })
}

return Promise.reject(error);
});

router.beforeEach((to, from, next) => {
if (localStorage['ystUserId'] == null || localStorage['ystUserId'].length > 20) {

localStorage.removeItem('ystToken');
localStorage.removeItem('ystUserId');
}

if (to.path.toString().substring(0, 7) === '/wecome') {


if (localStorage['ystToken'] && localStorage['ystUserId']) {
next();
} else {

localStorage.removeItem('ystToken');
localStorage.removeItem('ystUserId');
Toast({ message: '认证中...', duration: 0 });

let url = window.location.href;
String.prototype.getQueryString = function(name) {
let reg = new RegExp("(^|&|\\?)" + name + "=([^&]*)(&|$)"),
r;
if ((r = this.match(reg))) return unescape(r[2]);
return null;
}
let code1 = url.getQueryString("code");

var xdType = url.getQueryString("xdType");
if (code1 != null) {
getToken().then(response => {
getUserId(code1, xdType);
});
} else {
localStorage['ystBeforeUrl'] = location.href;
getCode(xdType);
}

}

} else {
if (to.query.code === undefined || to.query.code === '') {
if (window.sessionStorage.getItem("openId") == null) {
if (to.query.openId != null && to.query.openId !== '') {
window.sessionStorage.setItem("openId", to.query.openId)
}
}
next();
} else {
let WXcode = to.query.code;
console.log("code " + WXcode);
let sessionOpenId = window.sessionStorage.getItem(WXcode)
console.log("openId " + sessionOpenId);
if (sessionOpenId === undefined || sessionOpenId === '' || sessionOpenId == null) {
const url = '/wechat/getOpenId.do?code=' + WXcode;
axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
let openId = response.data.result.openId;
window.sessionStorage.setItem("openId", openId)
window.sessionStorage.setItem(WXcode, openId)
next();
} else {
console.log("获取OpenID失败")
}
}).catch(function(err) {
console.log("失败")
})
} else {
next();
}
}
}
});
router.afterEach((to, from, next) => {
window.scrollTo(0, 0);
});



/* eslint-disable no-new */




new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})
}



function cleanCache() {
const exp = 1000 * 3600 * 24 * 30; 
const data = localStorage.getItem('ystTokenTime');
if (data) {
if (new Date().getTime() - data > exp) {
localStorage.removeItem('ystToken');
localStorage.removeItem('ystUserId');


}
} else {
localStorage.removeItem('ystToken');
localStorage.removeItem('ystUserId');


}
}

cleanCache();


renderContent();




function getToken() {
localStorage.removeItem('ystToken');
return axios({
method: 'get',
url: '/wechat/getToken'
}).then((response) => {
Toast.clear();
if (response.data.code == '200') {
localStorage['ystToken'] = response.data.result;
localStorage['ystTokenTime'] = new Date().getTime();
} else {
alert('获取token失败')
}
}).catch(function(error) {
alert('请求token失败：' + error)
});
};

function getCode(xdType) {
axios({
method: 'get',
url: '/wechat/getCode?xdType=' + xdType
}).then((response) => {
Toast.clear();
if (response.data.code == '200') {

location.href = response.data.result;
} else {
alert('获取code失败')
}
}).catch(function(error) {
alert('获取code失败：' + error)
});
};

function getUserId(code, xdType) {
localStorage.removeItem('ystUserId');
axios({
method: 'get',
url: '/wechat/getUserId?code=' + code + '&token=' + localStorage['ystToken'] + '&xdType=' + xdType
}).then((response) => {
Toast.clear();
if (response.data.code == '200') {
localStorage['ystUserId'] = response.data.result;
let beforeUrl = localStorage['ystBeforeUrl'];
if (beforeUrl) {
localStorage.removeItem['ystBeforeUrl'];
location.href = beforeUrl;
} else {
location.reload();
}
} else {
Toast('认证失败');
}
}).catch(function(error) {
alert('请求userId失败：' + error)
});
}



// WEBPACK FOOTER //
// ./src/main.js